import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/Layout/Layout.js"
import ShareButtons from "../components/ShareButtons/ShareButtons.js"
import { BlogBio } from "../components/BlogBio/BlogBio.js"
import Seo from "../components/SEO/Seo.js"
import { Row, Col } from "react-bootstrap"
import TopNavbar from "../components/Navbar/Navbar.js"
import Img from "gatsby-image"

export default function Template({ data, location }) {
  const { markdownRemark } = data
  const { frontmatter, html } = markdownRemark
  const url = location.href

  return (
    <Layout>
      <Seo
        title={frontmatter.title}
        description={frontmatter.description}
        image={
          frontmatter.social &&
          "https://www.humaneer.org" +
            frontmatter.social.childImageSharp.fixed.src
        }
        type="article"
        url={url}
      />
      <Row className="mt-4">
        <TopNavbar />
      </Row>
      <Row></Row>
      <Row>
        <Col xs={3} className="sidebar">
          <div id="ezoic-pub-ad-placeholder-101"> </div>
        </Col>
        <Col>
          <div id="ezoic-pub-ad-placeholder-103"> </div>
          <div className="blog-post-container">
            {frontmatter.hero ? (
              <div className="hero-parent">
                <Img
                  fluid={frontmatter.hero.childImageSharp.fluid}
                  className="hero"
                />
              </div>
            ) : (
              ""
            )}
            <div className="blog-post">
              <div className="blog-post-meta">
                <h1 className="title">{frontmatter.title}</h1>
                <ShareButtons title={frontmatter.title} url={url} />
                <p className="date mt-4">
                  {frontmatter.date ? (
                    <>
                      <i>Last updated on </i>
                      <b>{frontmatter.date}</b>
                    </>
                  ) : (
                    ""
                  )}
                </p>
              </div>
              <div
                className="blog-post-content mt-4"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            </div>
            <BlogBio />
          </div>
        </Col>
      </Row>
    </Layout>
  )
}

export const pageQuery = graphql`
  query ($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        slug
        title
        description
        tags
        hero {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        social {
          childImageSharp {
            fixed(width: 1920, quality: 100) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    }
  }
`
